const feedEntries = {
  props: {
    dynamicClass: ".c-feed-entries.dynamicLoading",
    cssSelector: "c-feed-entries",
    cssSelectorItem: "c-feed-entries--item",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-feedEntries.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;
    const elements = baseFind.getElementsByClassName(this.props.cssSelector);
    for (let i = 0; i < elements.length; i++) {
      this.print(elements[i]);
    }
  },

  print: function ($el) {
    if ($el) {
      const url = $el.dataset.feedurl;

      if (url && url.length) {
        bcl.ajax.getRequest(null, url, this.afterGetContent.bind(this), $el);
      }
    }
  },

  afterGetContent: function (request, $el) {
    if ($el) {
      const items = $el.getElementsByClassName("c-feed-entries--item");
      const domParser = new DOMParser();
      const doc = domParser.parseFromString(request.response, "application/xml");
      const rssItems = doc.getElementsByTagName("item");

      for (let i = 0; i < items.length; i++) {
        this.printItem(items[i], rssItems[i]);
      }
    }
  },

  printItem: function ($item, $rssItem) {
    if ($item && $rssItem) {
      this.printElementContent($item.getElementsByClassName("c-launcher__imageside-header-title")[0], $rssItem.getElementsByTagName("title")[0]);

      this.printElementContent($item.getElementsByClassName("c-launcher__imageside-description")[0], $rssItem.getElementsByTagName("description")[0]);

      const dateString = $rssItem.getElementsByTagName("pubDate")[0];
      const date = new Date(dateString.innerText || dateString.textContent);

      if ($item.getElementsByClassName("c-timedate").length > 0) {
        $item.getElementsByClassName("c-timedate")[0].innerHTML = bcl.c.fastbooking.calendar.parseDateForInput(date, { day: "numeric", month: "short", year: "numeric" });
      }

      const $img = $item.getElementsByClassName("cmp-image__image")[0];
      const $thumbnailFeeds = $rssItem.getElementsByTagName("media:content")[0];

      if ($thumbnailFeeds == null) {
        $img.parentNode.removeChild($img);
      } else {
        $img.setAttribute("src", $thumbnailFeeds.getAttribute("url"));
        $img.setAttribute("alt", $rssItem.getElementsByTagName("title")[0].textContent);
      }

      const button = $item.getElementsByClassName("c-cta");
      if (button && button.length > 0) {
        button[0].setAttribute("href", $rssItem.getElementsByTagName("link")[0].innerHTML);
      }

      bcl.u.removeClass($item, "hidden");
    }
  },

  printElementContent: function ($element, $rssElement) {
    if ($element && $rssElement) {
      $element.innerHTML = $rssElement.innerText || $rssElement.textContent;

      if ($element.getElementsByTagName("p").length) {
        $element.innerHTML = $element.getElementsByTagName("p")[0].innerText || $element.getElementsByTagName("p")[0].textContent;
      }

      if ($element.innerHTML.length > 130) {
        $element.innerHTML = $element.innerHTML.substring(0, 130) + "...";
      }
    }
  },
};

export default feedEntries;
